// src/components/Footer.jsx
import React from "react";
import "../styles/Footer.css";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer>
      <div className="footer-content">
        <div className="footer-info">
          <p>
            © <span className="footer-year">{currentYear}</span> Movilidad y Seguridad Vial | Miraflores. 
            Todos los derechos reservados.
          </p>
          <div className="footer-links">
            <a href="#" className="footer-link">Política de Privacidad</a>
            <a href="#" className="footer-link">Términos de Uso</a>
            <a href="#" className="footer-link">Contacto</a>
            <a href="#" className="footer-link">Ayuda</a>
          </div>
        </div>
        
        <div className="footer-social">
          <a href="#" className="social-icon facebook" aria-label="Facebook">
            <i className="fab fa-facebook-f"></i>
          </a>
          <a href="#" className="social-icon twitter" aria-label="Twitter">
            <i className="fab fa-twitter"></i>
          </a>
          <a href="#" className="social-icon instagram" aria-label="Instagram">
            <i className="fab fa-instagram"></i>
          </a>
          <a href="#" className="social-icon linkedin" aria-label="LinkedIn">
            <i className="fab fa-linkedin-in"></i>
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;